/**
 * Professional category photos for pathway cards/heroes — one per
 * pathwayCategory() value. Same assets as the home-page support cards.
 */
export const PATHWAY_IMAGES = {
  nursing: require('@/assets/images/pathways/nursing.png'),
  'dental-hygiene': require('@/assets/images/pathways/dental-hygiene.png'),
  'respiratory-therapy': require('@/assets/images/pathways/respiratory-therapy.png'),
  'radiologic-technology': require('@/assets/images/pathways/radiologic-technology.png'),
  sonography: require('@/assets/images/pathways/sonography.png'),
  'physical-therapy': require('@/assets/images/pathways/physical-therapy.png'),
  'public-health': require('@/assets/images/pathways/public-health.png')
}

export const PATHWAY_IMAGE_ALTS = {
  nursing: 'Nursing professional in blue scrubs with a stethoscope',
  'dental-hygiene': 'Dental hygienist in scrubs with clinical instruments',
  'respiratory-therapy': 'Respiratory therapist with airway equipment',
  'radiologic-technology': 'Imaging professional holding a radiographic imaging plate',
  sonography: 'Sonographer performing an ultrasound exam',
  'physical-therapy': 'Physical therapist assistant with a resistance exercise band',
  'public-health': 'Public health professional at work'
}

export function pathwayImageFor(category) {
  return PATHWAY_IMAGES[category] || PATHWAY_IMAGES.nursing
}

export function pathwayImageAltFor(category) {
  return PATHWAY_IMAGE_ALTS[category] || PATHWAY_IMAGE_ALTS.nursing
}

/**
 * 3D field objects (brand-blue renders on the dark band) — used on card
 * grids in place of the repeating portraits. Fields without an object
 * yet fall back to the portrait.
 */
export const PATHWAY_OBJECTS = {
  nursing: '/images/fields/nursing.webp',
  'dental-hygiene': '/images/fields/dental-hygiene.webp',
  'respiratory-therapy': '/images/fields/respiratory-therapy.webp',
  'radiologic-technology': '/images/fields/radiologic-technology.webp',
  'physical-therapy': '/images/fields/physical-therapy.webp',
  sonography: '/images/fields/sonography.webp'
}

export function pathwayObjectFor(category) {
  return PATHWAY_OBJECTS[category] || null
}

/**
 * Cutout portraits (one person, transparent background) keyed by destination
 * credential, then field. Used where an EduNurse-built path would otherwise
 * show the EduNurse mark: the path hero and the card avatar.
 */
export const PATHWAY_PORTRAITS = {
  lpn: '/images/paths/portrait-lpn.webp',
  adn: '/images/paths/portrait-adn.webp',
  bsn: '/images/paths/portrait-bsn.webp'
}

export function pathwayPortraitFor(pathway, category) {
  const abbr = String((pathway && pathway.to_program && pathway.to_program.abbr) || '').toLowerCase().replace(/[^a-z]/g, '')
  if (PATHWAY_PORTRAITS[abbr]) return PATHWAY_PORTRAITS[abbr]
  return pathwayImageFor(category)
}

/**
 * Square photo tiles for path cards: the realistic program photo, keyed by the
 * destination credential (LPN / ADN / BSN have their own), then by field.
 */
export const PATHWAY_TILE_PHOTOS = {
  lpn: '/images/paths/photo-lpn.webp',
  adn: '/images/paths/photo-adn.webp',
  bsn: '/images/paths/photo-bsn.webp',
  nursing: '/images/paths/photo-nursing.webp',
  'dental-hygiene': '/images/paths/photo-dental-hygiene.webp',
  'physical-therapy': '/images/paths/photo-physical-therapy.webp',
  'radiologic-technology': '/images/paths/photo-radiologic-technology.webp',
  'respiratory-therapy': '/images/paths/photo-respiratory-therapy.webp',
  sonography: '/images/paths/photo-sonography.webp'
}

export function pathwayTilePhotoFor(pathway, category) {
  const abbr = String((pathway && pathway.to_program && pathway.to_program.abbr) || '').toLowerCase().replace(/[^a-z]/g, '')
  if (PATHWAY_TILE_PHOTOS[abbr]) return PATHWAY_TILE_PHOTOS[abbr]
  return PATHWAY_TILE_PHOTOS[category] || PATHWAY_TILE_PHOTOS.nursing
}

/** 4:3 hero crops of the same program photos, for the path page. */
export function pathwayHeroPhotoFor(pathway, category) {
  return pathwayTilePhotoFor(pathway, category).replace('/photo-', '/hero-')
}
